const paymentTypes = {
  EXISTING: 'existing',
  NEW: 'new',
};

export default paymentTypes;
